<template>
  <x-form
    modal
    open
    :title="$t('Notifiche email dei pannelli di controllo')"
    :submit-help="`* ${$t('Campo obbligatorio')}`"
    :submit-text="$t('Salva configurazione')"
    :disabled="sending"
    variant="medium"
    @submit="submit"
    @update:open="emit('cancel')"
  >
    <pf-empty-state v-if="configurationState.updating">
      <pf-empty-state-header :title="$t('Caricamento delle configurazioni...')" heading-level="h4">
        <template #icon>
          <pf-empty-state-icon>
            <pf-spinner />
          </pf-empty-state-icon>
        </template>
      </pf-empty-state-header>
    </pf-empty-state>

    <template v-else>
      <p>
        {{
          $t(
            'Inserisci qui le email a cui verranno inviate le segnalazioni di raggiungimento dei limiti di storage, traffico e risorse dei tuoi pannelli cloud hosting.',
          )
        }}
      </p>
      <p>{{ $t('Attenzione: queste impostazioni saranno valide solo per i nuovi ordini. Non verranno modificati i servizi già attivi') }}</p>
      <form-group :name="$t('Primaria')" required>
        <x-input
          v-model="configuration.primary_panel_email"
          type="email"
          maxlength="255"
          placeholder="Email di contatto primaria"
          name="primary_panel_email"
          required
        />
      </form-group>
      <form-group :name="$t('Secondaria')">
        <x-input
          v-model="configuration.secondary_panel_email"
          type="email"
          maxlength="255"
          placeholder="Email di contatto secondaria"
          name="secondary_panel_email"
        />
      </form-group>
    </template>
  </x-form>
</template>

<script lang="ts" setup>
import { $t as _t } from '@/i18n';
import { asyncComputed } from '@common/asyncComputed';
import { useLoginStore } from '@/store/login';
import { HostingSettingsResource } from '@/resources';
import { useFunctionRunningState } from '@/common/use';

const emit = defineEmits<{
  (e: 'submit'): void;
  (e: 'cancel'): void;
}>();

const resource = new HostingSettingsResource();
const { state: configurationState, result: configuration } = asyncComputed(() => resource.get(1));

const login = useLoginStore();

const { run: submit, isRunning: sending } = useFunctionRunningState(
  async () => {
    if (!login.id_azienda) {
      return;
    }

    await resource.put(login.id_azienda, configuration.value);
    emit('submit');
  },
  { preventMultiple: true },
);
</script>
